module.exports = __webpack_public_path__ + "02_short_brown.9538e4e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/02_short_brown.png
// module id = EUQK
// module chunks = 0